import { Container, Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { EmptyQuoteCard, QuoteCard, ShipmentCard, UserInfoBox } from '../components';
import type { IOrder } from '@/types';
import { Section } from '../components/Section';
import { useFetchDocs, useUser } from '@/hooks';
import { ROUTE_PATHS } from '@/constants';
import { pathJoin } from '@/utils';
import { SectionLoader } from '@/components/shared';

export const UserDashboard = (): JSX.Element => {
  const { t } = useTranslation();

  const user = useUser();
  const { docs, isLoading } = useFetchDocs();

  let shipments: IOrder[] = [];
  let quotes: IOrder[] = [];

  if (docs && docs.length > 0) {
    shipments = docs.filter(
      (doc) =>
        doc.type === 'shipment' &&
        doc.status !== 'SHIPMENT_CANCELED' &&
        doc.status !== 'SHIPMENT_DELIVERED'
    );

    quotes = docs.filter((doc) => doc.type === 'quote' && doc.status !== 'QUOTE_EXPIRED');
  }

  const quotePath = pathJoin([`/${ROUTE_PATHS.user}`, ROUTE_PATHS.userQuotes]);
  const shipmentPath = pathJoin([`/${ROUTE_PATHS.user}`, ROUTE_PATHS.usershipments]);

  return (
    <>
      <Container bg="white" maxW="8xl" px={{ base: 4, md: 8 }} py={{ base: 8, md: 9 }}>
        <UserInfoBox user={user} />
      </Container>
      <Box bg="brand.sand" py={16} w="full">
        {isLoading ? (
          <SectionLoader />
        ) : (
          <Container maxW="8xl" px={{ base: 4, md: 8 }}>
            <Flex direction="column" gap={10}>
              {shipments.length > 0 && (
                <Section
                  id="shipments"
                  path={shipmentPath}
                  title={t('ACCOUNT.DASHBOARD.SHIPMENTS')}
                  titleOnShowAll={t('ACCOUNT.DASHBOARD.SHOW_ALL_SHIPMENT_CTA')}
                >
                  {shipments.map((shipment) => (
                    <ShipmentCard key={shipment.id} shipment={shipment} />
                  ))}
                </Section>
              )}
              <Section
                id="quotes"
                path={quotes.length > 0 ? quotePath : undefined}
                title={t('ACCOUNT.DASHBOARD.QUOTES')}
                titleOnShowAll={t('ACCOUNT.DASHBOARD.SHOW_ALL_QUOTES_CTA')}
              >
                {quotes.length > 0 ? (
                  quotes.map((quote) => <QuoteCard key={quote.id} quote={quote} />)
                ) : (
                  <EmptyQuoteCard />
                )}
              </Section>
            </Flex>
          </Container>
        )}
      </Box>
    </>
  );
};
